import { useDecision } from '@optimizely/react-sdk'

export function useIsRafLandingPageExperimentEnabled() {
  const [isRafLandingPageExperimentEnabled] = useDecision('beetroots_ofx_raf_landing_page')

  return isRafLandingPageExperimentEnabled.variationKey === 't1'
}
